import MapLocation from "./location";

const calculateBounds = (locations: MapLocation[]): [[number, number], [number, number]] => {
    const bounds = locations.reduce(
        (acc, location) => {
            return {
                minLat: Math.min(acc.minLat, location.lat),
                maxLat: Math.max(acc.maxLat, location.lat),
                minLng: Math.min(acc.minLng, location.lng),
                maxLng: Math.max(acc.maxLng, location.lng),
            };
        },
        {
            minLat: Infinity,
            maxLat: -Infinity,
            minLng: Infinity,
            maxLng: -Infinity,
        }
    );
    return [
        [bounds.minLng, bounds.minLat],
        [bounds.maxLng, bounds.maxLat],
    ];
};

export default calculateBounds;
